import Module from 'mini-common-schema/lib/schema/Module';
import setShouldShowSearchBox from 'mini-mail-list-store/lib/actions/setShouldShowSearchBox';
import switchModule from 'owa-mail-store/lib/actions/switchModule';
import { endSearchSession, resetSearchState } from 'mini-mail-search-store';
import { getStore as getSearchStore } from 'mini-mail-search-store/lib/store/Store';
import { isMiniFeatureEnabled } from 'owa-mini-feature-flags';
import { logUsage } from 'owa-analytics';
import { selectFolder } from 'mini-mail-folder-actions';

/**
 * Search route to handle the search scenario
 */
export function searchRouterHandler() {
    if (isMiniFeatureEnabled('mini-unified-search')) {
        switchModule(Module.Search);
    } else {
        setShouldShowSearchBox(true /* shouldShowSearchBox */);
    }
}

export function searchCleanupRouterHandler(
    oldRoute: string[],
    oldParams: any,
    newRoute: string[],
    newParams: any
): boolean {
    const previouslySelectedFolderId = getSearchStore().previouslySelectedFolderId;
    if (previouslySelectedFolderId) {
        // If null, that means search never started.
        selectFolder(previouslySelectedFolderId);
    }
    resetSearchState();
    endSearchSession();
    setShouldShowSearchBox(false /* shouldShowSearchBox */);
    if (newParams && newParams.draftId) {
        return true;
    }
    logUsage('HardBackButton', ['Search_View']);
    return false;
}

export default searchRouterHandler;
